import React, { useState } from "react";
import { Container, Row, Col, Card, Image, Accordion } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./SchedualerComponent.css";

const SchedualerComponent = ({ schedualer, farmerTasks }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());

console.log('schedualer', schedualer);
  const currentYear = new Date().getFullYear();

  const normalizeDate = (d) =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate());

  const parseTaskDate = (value) => {
    if (!value) return null;
    if (value instanceof Date) return normalizeDate(value);
    if (typeof value === "string") {
      const v = value.trim();
      // Handle MM-DD (no year) by using current year
      if (/^\d{2}-\d{2}$/.test(v)) {
        const [mm, dd] = v.split("-").map((n) => parseInt(n, 10));
        return new Date(currentYear, mm - 1, dd);
      }
      // Handle YYYY-MM-DD without time
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
        const [yy, mm, dd] = v.split("-").map((n) => parseInt(n, 10));
        return new Date(yy, mm - 1, dd);
      }
      return new Date(v);
    }
    return new Date(value);
  };

  const isValidDate = (d) => d instanceof Date && !Number.isNaN(d.getTime());

  // Convert schedualer tasks to a consistent format
  const formattedSchedualerTasks = Array.isArray(schedualer)
  ? schedualer.map((task) => ({
      assignedDate: parseTaskDate(task.assigned_date ?? task.date_assigned),
      dueDate:
        parseTaskDate(task.due_date ?? task.dueDate) ||
        parseTaskDate(task.assigned_date ?? task.date_assigned),
      description: task.task_description,
      category: task.task_category,
      verified: false,
      completed: false,
      images: [],
      status: "Scheduled",
    }))
  : [];


  // Convert farmerTasks to the same format
  const assignedTasks = farmerTasks?.data?.assignedTasks || [];
  const formattedFarmerTasks = Array.isArray(assignedTasks)
    ? assignedTasks.map((task) => ({
      assignedDate: parseTaskDate(task.date_assigned ?? task.assigned_date),
        dueDate: parseTaskDate(task.due_date),
        description: task.task_description,
        category: task.task_category,
        verified: task.verified,
        completed: task.completed,
        images: task.images?.map((image) => image.imageUrl) || [],
        status: task.taskAnalyzer?.task_status,
        farmerImages: task.taskAnalyzer?.farmertaskImages || [],
        consultantImages: task.taskAnalyzer?.consultanttaskImages || [],
        supplierImages: task.taskAnalyzer?.suppliertaskImages || [],
        completedDate: task.taskAnalyzer?.completedDate ? new Date(task.taskAnalyzer.completedDate) : null,
        verifiedDate: task.taskAnalyzer?.verifiedDate ? new Date(task.taskAnalyzer.verifiedDate) : null,
      }))
    : [];

  const TASK_STATUS_COLORS = {
    Pending: "#9a9a9a",
    "In process": "#FACC15",
    Initiated: "#FACC15",
    Completed: "#2563EB",
    Verified: "#16A34A",
    Overdue: "#DC2626",
  };
  // Input tasks: Pending → In process (yellow) → Completed (blue) → Verified (green) → Overdue (red)
  // Other tasks: Pending → Completed (blue) → Verified (green) → Overdue (red) — no "In process"
  const isInputTask = (category) =>
    /inputs?/i.test(String(category || ""));

  const getTaskStatusColor = (status, category) => {
    if (!status) return TASK_STATUS_COLORS.Pending;
    const s = String(status).trim();
    if (/in\s*process|initiated/i.test(s) && isInputTask(category)) return TASK_STATUS_COLORS["In process"];
    if (/in\s*process|initiated/i.test(s) && !isInputTask(category)) return TASK_STATUS_COLORS.Pending;
    if (/completed/i.test(s)) return TASK_STATUS_COLORS.Completed;
    if (/verified/i.test(s)) return TASK_STATUS_COLORS.Verified;
    if (/overdue/i.test(s)) return TASK_STATUS_COLORS.Overdue;
    if (/pending/i.test(s)) return TASK_STATUS_COLORS.Pending;
    return TASK_STATUS_COLORS.Pending;
  };
  const getTaskStatusLabel = (status, category) => {
    if (!status) return "Pending";
    const s = String(status).trim();
    if (/in\s*process|initiated/i.test(s) && isInputTask(category)) return "In process";
    if (/in\s*process|initiated/i.test(s) && !isInputTask(category)) return "Pending";
    if (/completed/i.test(s)) return "Completed";
    if (/verified/i.test(s)) return "Verified";
    if (/overdue/i.test(s)) return "Overdue";
    if (/pending/i.test(s)) return "Pending";
    return status;
  };

    const categoryColors = {
      irrigation: "#07BBBE",
      "land prep": "#C96928",
      sowing: "#FF7310",
      inputs: "#3C58A5",
      harvesting: "#2DCA72",
      violation: "#FDDB1E",
    };

    const isSameDay = (date1, date2) => {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    };
  // Handle task dates for the calendar
  // const tileContent = ({ date, view }) => {
  //   if (view === "month") {
  //     const taskForDate = formattedSchedualerTasks.find(
  //       (task) => isSameDay(date, task.assignedDate) || (date >= task.assignedDate && date <= task.dueDate)
  //     );

  //     if (taskForDate) {
  //       let backgroundColor = "";
  //       const description = taskForDate?.category ? taskForDate.category.toLowerCase() : "";


  //       if (description.includes("irrigation")) {
  //         backgroundColor = "#07BBBE";
  //       } else if (description.includes("land prep")) {
  //         backgroundColor = "#C96928";
  //       } else if (description.includes("sowing")) {
  //         backgroundColor = "#FF7310";
  //       } else if (description.includes("inputs")) {
  //         backgroundColor = "#3C58A5";
  //       } else if (description.includes("harvesting")) {
  //         backgroundColor = "#2DCA72";
  //       } else if (description.includes("violation")) {
  //         backgroundColor = "#FDDB1E";
  //       }

  //       return (
  //         <div
  //           className="task-dot"
  //           style={{
  //             backgroundColor,
  //             width: "10px",
  //             height: "10px",
  //             borderRadius: "50%",
  //           }}
  //         />
  //       );
  //     }
  //   }
  //   return null;
  // };

  const tileContent = ({ date, view }) => {
    if (view !== "month") return null;
  
    const taskForDate = formattedSchedualerTasks.find((task) => {
      if (!isValidDate(task.assignedDate) || !isValidDate(task.dueDate)) return false;
      const day = normalizeDate(date);
      return (
        isSameDay(day, task.assignedDate) ||
        (day >= task.assignedDate && day <= task.dueDate)
      );
    });
  
    if (!taskForDate) return null;
  
    const category = taskForDate.category?.toLowerCase().trim();
    const taskColor = categoryColors[category] || "#999";
  
    return (
      <div className="calendar-tile-indicators">
        <span
          className="calendar-dot calendar-dot-task"
          style={{ backgroundColor: taskColor }}
          title={taskForDate.category}
        />
      </div>
    );
  };
 
   console.log('---', selectedDate);
  
  return (
    <Container className="schedule-container p-4">
      <h4 className="schedule-title">Scheduler</h4>
      <Row>
        <Col md={6} className="taskScheduler">
          <Card className="mb-3 p-3 calendar-card">
            <h5>Task Calendar</h5>
            <Calendar
              onChange={setSelectedDate}
              value={selectedDate}
              tileContent={tileContent}
              className="task-calendar"
              next2Label={null}
              prev2Label={null}
            />

            
          </Card>

          <Card className="mb-3 p-3">
  {/* <h6>Task Category Legend</h6> */}
  <div className="legend-container">
    {Object.entries(categoryColors).map(([category, color]) => (
      <div key={category} className="legend-item">
        <span
          className="legend-dot"
          style={{
            backgroundColor: color,
          }}
        />
        {category.charAt(0).toUpperCase() + category.slice(1)}
      </div>
    ))}
  </div>
</Card>


          {/* Farmer & Scheduled Tasks */}
          <Card className="mb-3 p-3 schedule-card">
            <h5>
             
               Assigned Tasks</h5>
            <Accordion>
              {formattedFarmerTasks.length === 0 ? (
                <p>No tasks assigned.</p>
              ) : (
                formattedFarmerTasks.map((task, idx) => {
                  // Check if task has farmerImages
                  const hasFarmerImages = task.farmerImages.length > 0;
                  const hasConsultantImages = task.consultantImages.length > 0;
                  const hasSupplierImages = task.supplierImages.length > 0;

                   // Log farmer and consultant images for verification
    
                  
                  return (
                    <Accordion.Item eventKey={`task-${idx}`} key={idx}>
                      <Accordion.Header>
                        <span
                          className="me-2 task-status-dot"
                          style={{ backgroundColor: getTaskStatusColor(task.status, task.category) }}
                          title={getTaskStatusLabel(task.status, task.category)}
                        />
                        <p className="task-description">
                          {task.description}
                        </p>
                        <span
                          className="task-status-badge ms-2"
                          style={{
                            color: getTaskStatusColor(task.status, task.category),
                            fontWeight: 600,
                          }}
                        >
                          {getTaskStatusLabel(task.status, task.category)}
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          <strong>Category:</strong> {task.description || "General"}
                        </p>
                        {/* <p>
                          <strong>Status:</strong> {task.status}
                        </p> */}
                        <small className="text-muted">
                          Assigned: {task.assignedDate.toLocaleDateString()} | Due: {task.dueDate.toLocaleDateString()}
                        </small>

                        {hasFarmerImages || hasConsultantImages  || hasSupplierImages ? (
            <Row className="mt-2">
              {task.farmerImages.map((imageUrl, imgIdx) => (
                <Col xs="auto" key={`farmer-${imgIdx}`}>
                  <Image src={imageUrl} className="task-image" rounded />
                </Col>
              ))}
              {task.consultantImages.map((imageUrl, imgIdx) => (
                <Col xs="auto" key={`consultant-${imgIdx}`}>
                  <Image src={imageUrl} className="task-image" rounded />
                </Col>
              ))}
              {task.supplierImages.map((imageUrl, imgIdx) => (
                <Col xs="auto" key={`consultant-${imgIdx}`}>
                  <Image src={imageUrl} className="task-image" rounded />
                </Col>
              ))}
             <small className="text-muted">
  {task.completedDate ? `Completed Date: ${task.completedDate.toLocaleDateString()}` : ""}
  {task.status && /verified/i.test(String(task.status)) && task.verifiedDate ? ` | Verified Date: ${task.verifiedDate.toLocaleDateString()}` : ""}
</small>


            </Row>
            
          ) : (
            <p className="pendingTasks">No images available.</p>
          )}
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })
              )}
            </Accordion>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SchedualerComponent;
